import React from "react";

export interface IconDuplicateProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const IconDuplicate: React.FC<IconDuplicateProps> = ({
  width = 23,
  height = 25,
  fill = "#006231",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 23 25"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M16.4286 21.875V23.8281C16.4286 24.4753 15.8769 25 15.1964 25H1.23214C0.551641 25 0 24.4753 0 23.8281V5.85938C0 5.21216 0.551641 4.6875 1.23214 4.6875H4.92857V19.1406C4.92857 20.6484 6.21827 21.875 7.80357 21.875H16.4286ZM16.4286 5.07812V0H7.80357C7.12307 0 6.57143 0.524658 6.57143 1.17188V19.1406C6.57143 19.7878 7.12307 20.3125 7.80357 20.3125H21.7679C22.4484 20.3125 23 19.7878 23 19.1406V6.25H17.6607C16.983 6.25 16.4286 5.72266 16.4286 5.07812ZM22.6391 3.56304L19.2537 0.343213C19.0227 0.123458 18.7093 1.62498e-06 18.3825 0L18.0714 0V4.6875H23V4.39165C23 4.08086 22.8702 3.7828 22.6391 3.56304Z" />
  </svg>
);
